import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import './Condition.css';
import ConditionForm from "./ConditionForm/ConditionForm";
import AddIcon from "@material-ui/icons/Add";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { Tooltip } from "@material-ui/core";
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
export default function Condition({
    variables,
    setOpenVariable,
    conditions,
    setConditions,
    addEmptyCondition,
    deleteCondition,
    setConditionField
}) {
    const [active, setActive] = useState(false);
    const [focusedSourceInput, setFocusedSourceInput] = useState("");
    const { t } = useTranslation();
    const label = "GENERAL.CONDITION."

    const implementLogicalOperator = async (isActive, operator, index) => {
        setActive(isActive)
        await setConditionField("op_logic", operator, index);
    }

    return (
        <div className="condition-root-handler">
            {conditions.length > 0 && conditions.map((item, i) => {
                return (
                    <div className="condition-root" key={i}>
                        <div className="condition-header">
                            {t(label + "HEADER").toUpperCase()} {`# ${i + 1}`}
                            {conditions.length > 1 && (
                                <Tooltip title={t(label + "DELETE-CONDITION")} placement="top">
                                    <DeleteForeverOutlinedIcon className="delete-condition" onClick={() => deleteCondition(i)} />
                                </Tooltip>
                            )}
                        </div>
                        <div className="condition-content">
                            {conditions.length > 0 ?
                                (
                                    <ConditionForm fields={item} index={i} setConditionField={setConditionField}
                                        setFocusedSourceInput={setFocusedSourceInput}
                                        focusedSourceInput={focusedSourceInput} />
                                ) : (
                                    <ConditionForm fields={conditions[0]} index={0}
                                        setConditionField={setConditionField}
                                        setFocusedSourceInput={setFocusedSourceInput}
                                        focusedSourceInput={focusedSourceInput} />
                                )}
                        </div>
                        {item.op_logic === "" ? (
                            <>
                                <div className={`add-condition ${active ? "active" : "passive"}`}
                                    onClick={() => setActive(!active)}>
                                    <AddIcon />
                                </div>
                                <div className={`logical-operators ${active ? "active" : "passive"}`}>
                                    <div className="operator and"
                                        onClick={() => implementLogicalOperator(false, 'and', i)}>
                                        AND
                                    </div>
                                    <div className="or operator"
                                        onClick={() => implementLogicalOperator(false, 'or', i)}>
                                        OR
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="selected-operator">
                                {item.op_logic?.toUpperCase()}
                            </div>
                        )}

                    </div>
                )
            })}
        </div>
    );
}
